module.exports = __webpack_public_path__ + "img/Bank-of-China.c4809f91.svg";